import { render, staticRenderFns } from "./DanhSachCapDaiLy.vue?vue&type=template&id=be0041ba&scoped=true&"
import script from "./DanhSachCapDaiLy.vue?vue&type=script&lang=js&"
export * from "./DanhSachCapDaiLy.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachCapDaiLy.vue?vue&type=style&index=0&id=be0041ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0041ba",
  null
  
)

export default component.exports